export enum ContainerState {
  contentPlaceholder = 'contentPlaceholder',
  onboard = 'onboard',
  noResult = 'noResult',
  done = 'done'
}
